import { useContext } from 'react'
import ProductPageContext, { productContextInitialState } from '../contexts/ProductPageContext'

const useProductPageContext = () => {
  const context = useContext(ProductPageContext) || productContextInitialState
  if (context === undefined) {
    throw new Error('useProductPageContext must be used within a ProductPageProvider')
  }
  return context
}

export default useProductPageContext
